module.exports = __webpack_public_path__ + "img/banner_emm.89b509c1.jpg";